import { render, staticRenderFns } from "./cataractnnvmphco.vue?vue&type=template&id=10c0abfc&scoped=true"
import script from "./cataractnnvmphco.vue?vue&type=script&lang=js"
export * from "./cataractnnvmphco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c0abfc",
  null
  
)

export default component.exports